import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';

interface BottomBarProps {
  leftButton?: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
  };
  rightButton?: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
  };
}

/**
 * BottomBar — Flutter-native style.
 * Matches Flutter's bottom action panel: top shadow, 48px button height,
 * 12px vertical + 16px horizontal padding, borderRadius 12.
 */
export const BottomBar: React.FC<BottomBarProps> = ({ leftButton, rightButton }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1.5,
        px: 4,
        py: 3,
        alignItems: 'center',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        boxShadow: '0px -2px 8px rgba(0, 0, 0, 0.06)',
      }}
      className="safe-area-bottom"
    >
      {leftButton && (
        <Button
          variant="outlined"
          fullWidth
          onClick={leftButton.onClick}
          disabled={leftButton.disabled}
          sx={{ height: 48 }}
        >
          {leftButton.label}
        </Button>
      )}

      {rightButton && (
        <Button
          variant="contained"
          fullWidth
          onClick={rightButton.onClick}
          disabled={rightButton.disabled || rightButton.loading}
          sx={{ height: 48 }}
          startIcon={rightButton.loading ? <CircularProgress size={18} color="inherit" /> : undefined}
        >
          {rightButton.label}
        </Button>
      )}
    </Box>
  );
};
